export default __webpack_public_path__ + "static/metamask-6210de139dee9972448438b5e94623ef.svg";